import axios from "axios";

const BASE = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: `${BASE}/api`,
  timeout: 5000,
});

export default api;
